<template>

<template-section v-if="!compact" :config="config" :linkName="linkName" :sectionName="sectionName"  @deSelectSection="$emit('deSelectSection')" @selectSection="$emit('selectSection')" @removeSection="$emit('removeSection')">
	<!-- <template v-slot:default> -->
		<h2 class="section-title featured-collections-title">
			{{ title }}
		</h2>
		<div class="featured-collections columns" :class="[ 'columns-' + columns ]" v-if="!config.drag">
			<div class="featured-collection tile" v-for="(featuredCollection, index) in featuredCollections">
				<img :src="featuredCollection" :key="index"></img>
				<div class="department-label">Featured Collection</div>
			</div>
		</div>
	<!-- </template> -->

	<template v-slot:sectionEdit>
		<div class="section-title-edit">
			<label>Title</label>
			<input type="text" v-model="title">
		</div>
		<div class="columns-2">
			<h3>Columns</h3>
			<select v-model="columns">
				<option value="2">2</option>
				<option value="3">3</option>
				<option value="4">4</option>
			</select>
			<h3>Rows</h3>
			<p>Your home page will display Featured Collection rows based on the tiles you select in the Featured Colletctions program.</p>
			<a href="/dashboard/website/featured-collections" target="_blank" class="website-link">Add Featured Collections</a>
		</div>
	</template>
</template-section>

<div v-else>Featured Collections <i class="fas fa-grip-horizontal"></i></div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'featured-collections',
	props: ['compact', 'config', 'options'],
	data() {
		return {
			linkName: "/website/featured-collections",
			sectionName: "Featured Collections"
		}
	},
	mounted() {
		if (this.options)
			this.featured_collections = this.options.featured_collections
	},
	watch: {
		config() {
			if (this.config.index == this.config.selectedSection)
				this.fetchData()
		},
		featured_collections: {
			handler: function(value) {
				this.updateTemplateData({ path: 'pageSections[' + this.computedIndex + '].options.featured_collections', value: value })
				this.updateVersion()
			},
			deep: true
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData',
        ]),
		title: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.title
			},
			set(value) {
				this.updateTemplateData({ path: `pageSections[${this.localIndex}].options.title`, value: value })
			}
		},
		columns: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.columns
			},
			set(value) {
				this.updateTemplateData({ path: `pageSections[${this.localIndex}].options.columns`, value: value })
			}
		},
		localIndex() {
			if (!this.config) return
			return this.config.index - 1
		},
		featuredCollections() {
			var featuredCollections = []
			for (var i = 0; i < (this.columns); i++) {
				featuredCollections.push('https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/templates/dark/generic-department-dark.jpg')
			}
			return featuredCollections
		}
	},
	methods: {
        ...mapActions('website_module', [
            'updateTemplateData'
        ]),
		fetchData() {
			this.apiCall({ destination: 'get_list_featured_collections' }).then(obj => {
				this.availableCollections = obj.available_collections
			}).catch(err => {
				console.log(err)
			})
		},
		addCollection(index, featuredCollection) {
			this.$set(this.featured_collections, this.featured_collections.length, featuredCollection)
			this.availableCollections.splice(index, 1)
		},
		removeCollection(index, featuredCollection) {
			this.featured_collections.splice(index, 1)
			this.$set(this.availableCollections, this.availableCollections.length, featuredCollection)
		}
	}
}
</script>
<style lang="scss">
.featured-collections {
	grid-gap: 1rem;
}
.featured-collection.tile {
	font-size: 2.2vw;
}
</style>
